import React, { useEffect, useState } from "react";
import "../styles/Cover.css";

import cover2 from "../images/cover/cover1.png";
import cover1 from "../images/cover/volvo2.png";

const images = [cover1, cover2];

const Cover = () => {
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveImage((prev) => (prev + 1) % images.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="cover-section">
      <div className="cover-container">
        <div className="cover-content">
          <h1>
            Drive Clean, Live
            <br />
            Fresh, Look
            <br />
            Sharp
          </h1>

          <p>Book an appointment with us today below in minutes.</p>

          <div className="cover-buttons">
            <a href="/carwash-appointment" className="cover-btn primary">
              Car Wash Appointment
            </a>

            <a href="/carpet-pickup" className="cover-btn secondary">
              Carpet Pick Up
            </a>
            <a href="/water-refill" className="cover-btn secondary">
              Water Refill  
            </a>
          </div>
        </div>

        <div className="cover-image-wrapper">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt="Cleaning service"
              className={`cover-image ${
                index === activeImage ? "active" : ""
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cover;